module.exports = __webpack_public_path__ + "static/media/doclad11.6db09072.pdf";